// first  section for ./index.page.tsx
import { FC } from 'react'
import NextLink from 'next/link'
import Image from 'next/image'
import { useMobileDetector } from '../../hooks/use-mobile-detector'

const sectionClass = [
  'bg-[#ffeee2] w-full  relative flex',
  'flex-col px-6 py-34px',
  'laptop:flex-row laptop:justify-end laptop:px-0 laptop:py-76px',
].join(' ')

const leftContainerClass = [
  'flex',
  'w-full flex-col',
  'laptop:w-878px laptop:absolute laptop:left-30 laptop:top-94px laptop:z-10',
].join(' ')

const titleTextClass = ['text-[#fc7216] font-semibold leading-tight', 'text-40', 'laptop:text-80'].join(' ')

const BellaIcon = 'https://cdn.pudutech.com/website/images/landingpage-texas/s1-bella-icon.png'
const LocationIcon = 'https://cdn.pudutech.com/website/images/landingpage-texas/location.svg'
const Banner = 'https://cdn.pudutech.com/website/images/landingpage-texas/texas-banner.png'
const BannerH5 = 'https://cdn.pudutech.com/website/images/landingpage-texas/texas-banner_h5.png'
const ForwardIcon = 'https://cdn.pudutech.com/website/images/landingpage-texas/s1-forward-icon.svg'

const SectionOne: FC = () => {
  const isMobile = useMobileDetector()

  return (
    <section className={sectionClass}>
      <div className={leftContainerClass}>
        <p className={titleTextClass}>
          Food Running Robot <span className={'text-60 laptop:text-120'}>Trial</span>
        </p>

        <div
          className={[
            'flex justify-between',
            'flex-row-reverse  mt-6',
            'laptop:gap-y-12 laptop:flex-col laptop:mt-8',
          ].join(' ')}
        >
          <div
            className={[
              'flex flex-row items-center font-semibold text-black',
              'gap-x-2 text-24',
              'laptop:gap-x-4  laptop:text-40',
            ].join(' ')}
          >
            <span>BellaBot</span>
            <div className={['relative', 'w-25px h-25px', 'laptop:w-55px laptop:h-55px'].join(' ')}>
              <Image layout="fill" alt="bellabot icon" src={BellaIcon} />
            </div>
          </div>

          <div
            className={[
              'flex flex-row items-center gap-x-1 laptop:gap-x-2 text-[#fc7216] font-bold text-16 laptop:text-24',
            ].join(' ')}
          >
            <div className={['relative', 'w-6 h-6', 'laptop:w-8 laptop:h-8'].join(' ')}>
              <Image layout="fill" alt="location icon" src={LocationIcon} />
            </div>
            <span>USA</span>
          </div>
        </div>

        <NextLink href={'#form'}>
          <button className="hidden laptop:flex flex-row items-center gap-x-2 w-fit py-7 px-10 rounded-full bg-[#fc7216] text-white text-32 font-semibold mt-182px">
            Apply for trial
            <div className={['relative w-10 h-10'].join(' ')}>
              <Image alt="forward icon" src={ForwardIcon} layout="fill" />
            </div>
          </button>
        </NextLink>
      </div>

      <div
        className={['relative', 'w-350px h-105 mt-8', 'laptop:mt-0 laptop:w-[61.15vw] laptop:h-[43.75vw]'].join(' ')}
      >
        <Image layout="fill" alt="banner" src={isMobile ? BannerH5 : Banner} />
      </div>
    </section>
  )
}

export default SectionOne
